module.exports = __webpack_public_path__ + "static/media/ZTDC07.57799422.jpg";